import { APIHelpers } from './apiHelpers';

export const SIGNATURE_SERVICE = 'https://signature.api.manifoldxyz.dev';
export const signatureApiBaseUrl =
  import.meta.env.DEV && import.meta.env.VITE_APP_SIGNATURE_SERVICE
    ? import.meta.env.VITE_APP_SIGNATURE_SERVICE
    : `${SIGNATURE_SERVICE}`;

class SignatureApi extends APIHelpers {
  constructor() {
    super();
    this.baseUrl = signatureApiBaseUrl;
  }

  /**
   * For use with the L1 claim extension contract after burning on L2.
   * Be sure to check the status code to ensure the request was successful
   * and returned a solid signature.
   *
   * @param redemptionPayload -- wallet, instance id, and optional redemption code
   * @returns message, signature, nonce, expiration, status
   * @note status is 200 with good request
   * @note status is 400 with bad secret
   * @note status is 406 with expired signature
   * @note status is 500 if there is a critical ISE
   *
   */
  async claimRedemptionSign(redemptionPayload: {
    walletAddress: string;
    extensionAddress: string;
    instanceId: number;
    redemptionCode?: string;
    mintCount: number;
  }): Promise<{
    status: 400 | 406 | 500 | 200;
    signature: string;
    message: string;
    nonce: string;
    expiration: number;
  }> {
    try {
      const data = await this.post('/redemption-sign/', {
        body: JSON.stringify(redemptionPayload),
      });
      return data;
    } catch (error) {
      console.error('Error claiming redemption signature:', error);
      throw error;
    }
  }
}

export const signatureApi = new SignatureApi();
